export { default } from './BarresVotsDiputats';
